import { Injectable } from '@angular/core';
import { UrlParamsService } from '../../core/services/url-params.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from '../../auth.config';
import { Language } from '../../shared/models/language';
import { MasterDataService } from '../../shared/services/master-data.service';
import { StorageService } from '../../shared/services/storage.service';
@Injectable({
	providedIn: 'root'
})
export class AuthService {
	urlParams: any = {};
  prefixList: string[];

	constructor(
		private oauthService: OAuthService,
    private urlParamsService: UrlParamsService,
    private storageService: StorageService,
    private masterService: MasterDataService
		) {
		const homeserveparams = this.urlParamsService.getDecodedParams();
		this.getParamsUrl('urlParams', homeserveparams);
		this.configureOAuth();
		
    this.prefixList = this.masterService.getPhonePrefixList();
	}

	public getParamsUrl(storageParam: string, homeserveparams: any){
		if (homeserveparams.data !== ''){
			this.urlParams = {
				data: homeserveparams.data ? homeserveparams.data : '',
				lang: homeserveparams.lang ? this.masterService.getLanguages().find(language => language.i18nKey === homeserveparams.lang) : '',
				utm_source: homeserveparams.utm_source ? homeserveparams.utm_source : '',
				utm_medium: homeserveparams.utm_medium ? homeserveparams.utm_medium : '',
				utm_campaign: homeserveparams.utm_campaign ? homeserveparams.utm_campaign : '',
			}
			this.storageService.save(storageParam, this.urlParams);
		}
	}
	
	private configureOAuth() {
		this.oauthService.configure(authConfig);
		this.oauthService.loadDiscoveryDocumentAndLogin();
		this.oauthService.setupAutomaticSilentRefresh();
	}

	public isValidToken() {
		return this.oauthService.hasValidAccessToken();
	}

	public logout() {
		this.oauthService.revokeTokenAndLogout();
	}
}
